import { render, staticRenderFns } from "./DhmeWkbDocumentsLibrary.vue?vue&type=template&id=4c8e834e&scoped=true"
import script from "./DhmeWkbDocumentsLibrary.vue?vue&type=script&lang=js"
export * from "./DhmeWkbDocumentsLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e834e",
  null
  
)

export default component.exports